import React from "react";

interface TabProps {
  id: string;
  label: string;
}

interface TabItemProps {
  tabList: Partial<TabProps>[];
  activeTab: string;
  handleClick: (d: any) => void;
}

const SimpleTabItems: React.FC<TabItemProps> = ({
  tabList = [],
  activeTab = "",
  handleClick = () => {},
}) => {
  return (
    <div className="simple-tab-wrapper">
      <div className="simple-tab-scroll">
        <div className="simple-tab-list">
          {tabList?.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => handleClick(tab)}
              className={`simple-tab-btn ${
                activeTab === tab.id ? "active" : ""
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SimpleTabItems; 


// import React from "react";

// interface TabProps {
//   id: string;
//   label: string;
// }

// interface TabItemProps {
//   tabList: Partial<TabProps>[];
//   activeTab: string;
//   handleClick: (d: any) => void;
// }

// const SimpleTabItems: React.FC<TabItemProps> = ({
//   tabList = [],
//   activeTab = "",
//   handleClick = () => {},
// }) => {
//   return (
//     <>
//       <div className="mb-2 py-1">
//         <div
//           style={{
//             overflowX: "auto",
//             overflowY: "hidden",
//             scrollbarWidth: "none",
//           }}
//         >
//           <ul
//             className="nav nav-tabs d-flex flex-nowrap gap-2 pb-1 px-1 mb-0"
//             style={{ width: "max-content", minWidth: "100%" }}
//           >
//             {tabList?.map((tab) => (
//               <li className="nav-item" key={tab.id}>
//                 <button
//                   className={`nav-link border-0 border-bottom rounded-0 pb-1 px-1 ${
//                     activeTab === tab.id
//                       ? "active text-primary border-primary"
//                       : ""
//                   }`}
//                   onClick={() => handleClick(tab)}
//                 >
//                   {tab.label}
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SimpleTabItems;
